export default __webpack_public_path__ + "static/media/sec311.43477513.jpeg";